import { ImageFit as FluentImageFit, ImageShape as FluentImageShape } from "@fluentui/web-components";
/** Fit values for {@link Image}. */
export const ImageFits = { ...FluentImageFit };
/** Shape values for {@link Image}. */
export const ImageShapes = { ...FluentImageShape };
//# sourceMappingURL=image.options.js.map